export default "__VITE_ASSET__hsdDxlsq__"